import { authenticatedFetch } from './authenticatedFetch';

const API_ORIGIN = new URL(
  process.env.REACT_APP_API_URL || 'http://localhost:3001', window.location.href,
).origin;

// Install once at boot; only the configured API receives the bearer.
if (!(window as any).__latoFetchPatched) {
  window.fetch = authenticatedFetch(window.fetch.bind(window), API_ORIGIN);
  (window as any).__latoFetchPatched = true;
}
